/** Approval service reasons (sent to POST /approval/submit) */
export enum ApprovalReason {
  VACATION_SUPPLY = "VACATION_SUPPLY",
  LOST_MEDICATION = "LOST_MEDICATION",
  EMERGENCY = "EMERGENCY",
  DOSE_CHANGE = "DOSE_CHANGE",
  ON_HAND_SUPPLY_ADJUSTMENT = "ON_HAND_SUPPLY_ADJUSTMENT",
}

/** UCS override reasons (sent to POST /override/create) */
export enum OverrideReason {
  VACATION_SUPPLY = "VACATION_SUPPLY",
  LOST_MEDICATION = "LOST_MEDICATION",
  NATURAL_DISASTER = "NATURAL_DISASTER",
  DOSE_CHANGE = "DOSE_CHANGE",
  ON_HAND_SUPPLY_ADJUSTMENT = "ON_HAND_SUPPLY_ADJUSTMENT",
}

/** Maps approval reason to UCS override reason */
export const APPROVAL_TO_OVERRIDE_REASON: Record<ApprovalReason, OverrideReason> = {
  [ApprovalReason.VACATION_SUPPLY]: OverrideReason.VACATION_SUPPLY,
  [ApprovalReason.LOST_MEDICATION]: OverrideReason.LOST_MEDICATION,
  [ApprovalReason.EMERGENCY]: OverrideReason.NATURAL_DISASTER,
  [ApprovalReason.DOSE_CHANGE]: OverrideReason.DOSE_CHANGE,
  [ApprovalReason.ON_HAND_SUPPLY_ADJUSTMENT]: OverrideReason.ON_HAND_SUPPLY_ADJUSTMENT,
};

/** Requester roles for the approval service */
export enum RequesterRole {
  CUSTOMER = "CUSTOMER",
  GENERALIST = "GENERALIST",
  PHARMACIST = "PHARMACIST",
  TECHNICIAN = "TECHNICIAN",
}

/** Approval statuses returned from the approval service */
export enum ApprovalStatus {
  GRANTED = "GRANTED",
  REQUIRES_AUTHORIZED_HUMAN_REVIEW = "REQUIRES_AUTHORIZED_HUMAN_REVIEW",
  DENIED = "DENIED",
  CANCELLED = "CANCELLED",
}

/** UCS consumption computation strategies */
export enum ConsumptionComputationStrategy {
  CACHE_FIRST = "CACHE_FIRST",
  RECOMPUTE = "RECOMPUTE",
}
